module.exports = __webpack_public_path__ + "static/img/img-wikipedia_banner.0641aa5a.png";